import { Method } from '../../../../packages/neb-api-client/src/utils/api-client-utils';
import ApiClientV2 from '../../../../packages/neb-api-client/src/utils/api-client-v2';
import { mapToJob } from '../mappers/job-map';

const dataIntegrityApiClient = new ApiClientV2({
  microservice: 'dataintegrity',
});

export const getDataIntegrityJobs = async () => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/data-integrity-check/jobs',
  });
  const result = res.map(x => mapToJob(x));
  return result;
};

export const startDataIntegrityJob = async (parameter = {}) => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.POST,
    path: '/api/v1/data-integrity-check/jobs',
    body: JSON.stringify(parameter),
  });
  return res;
};

export const getDataIntegrityJobQueries = async jobId => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/data-integrity-check/jobs/:jobId/queries',
    replacements: { jobId },
  });
  return res;
};

export const getDataIntegrityQueryList = async () => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/data-integrity-check/queries/list',
  });
  return res;
};

export const getDataIntegrityQueryJobs = async queryId => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/data-integrity-check/queries/:queryId',
    replacements: { queryId },
  });
  return res;
};

export const getDataIntegrityQueryJob = async (queryId, jobId) => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/data-integrity-check/queries/:queryId/jobs/:jobId',
    replacements: { queryId, jobId },
  });
  return res;
};

export const getDataIntegrityQueryJobDetails = async (queryId, jobId) => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/data-integrity-check/queries/:queryId/jobs/:jobId',
    replacements: { queryId, jobId },
  });
  return res;
};

export const getDataIntegrityJobSchedule = async () => {
  const res = await dataIntegrityApiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/data-integrity-check/schedule',
  });

  if (!res) {
    return { hour: null, minute: null };
  }
  return res;
};
